/**
 * React Router equivalents for pathname / imperative navigation.
 */
import {
  useNavigate,
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";

export function usePathname() {
  const { pathname } = useLocation();
  return pathname;
}

export function useRouter() {
  const navigate = useNavigate();
  return {
    push: (href: string) => navigate(href),
    replace: (href: string) => navigate(href, { replace: true }),
    prefetch: () => {},
    back: () => navigate(-1),
    forward: () => navigate(1),
    refresh: () => window.location.reload(),
  };
}

export { useParams, useSearchParams };
